/** Fecha de hoy en Colombia (America/Bogota) como YYYY-MM-DD. */
export const fechaHoyBogota = () =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Bogota",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());

export const filtrosDiaActual = () => {
  const hoy = fechaHoyBogota();
  return {
    usuario: "",
    fechaDesde: hoy,
    fechaHasta: hoy,
    terminal: "",
    centroCostos: "",
  };
};

/** Texto legible de parqueaderos resueltos por centro de costos. */
export const etiquetaParqueaderos = (parqueaderos) => {
  const lista = Array.isArray(parqueaderos) ? parqueaderos : [];
  if (!lista.length) return "";
  return lista
    .map((p) => {
      const nombre = String(p.nombrePark || p.nombre_park || "").trim();
      const cod = String(p.codPark || p.cod_park || "").trim();
      if (nombre && cod) return `${nombre} (${cod})`;
      return nombre || (cod ? `Park ${cod}` : "");
    })
    .filter(Boolean)
    .join(", ");
};

export const esUsuarioValido = (usuario) => {
  const t = String(usuario || "").trim();
  if (!t) return false;
  const lower = t.toLowerCase();
  return lower !== "anónimo" && lower !== "anonimo";
};

const ACCIONES_CLIENTES_OCULTAS = new Set([
  "modificar cliente jurídico",
  "modificar cliente natural",
]);

export const ocultarAuditoriaClientes = (registros) =>
  (Array.isArray(registros) ? registros : []).filter(
    (row) =>
      !ACCIONES_CLIENTES_OCULTAS.has(
        String(row.accion || "")
          .trim()
          .toLowerCase()
      )
  );

export const filtrarUsuariosValidos = (registros) =>
  ocultarAuditoriaClientes(registros).filter((r) => esUsuarioValido(r.usuario));

/**
 * Agrupa registros en filas usuario | acción | cantidad.
 * Omite usuarios vacíos / Anónimo.
 */
export const construirResumenPorUsuarioAccion = (registros) => {
  const mapa = new Map();

  filtrarUsuariosValidos(registros).forEach((row) => {
    const usuario = String(row.usuario).trim();
    const accion = String(row.accion || "").trim() || "(sin acción)";
    const clave = `${usuario.toLowerCase()}|${accion.toLowerCase()}`;
    const actual = mapa.get(clave);
    if (actual) {
      actual.cantidad += 1;
    } else {
      mapa.set(clave, { usuario, accion, cantidad: 1 });
    }
  });

  return Array.from(mapa.values()).sort((a, b) => {
    const porUsuario = a.usuario.localeCompare(b.usuario, "es");
    if (porUsuario !== 0) return porUsuario;
    return b.cantidad - a.cantidad || a.accion.localeCompare(b.accion, "es");
  });
};

/** Agrupa el resumen plano por usuario (para rowspan en la tabla). */
export const agruparResumenPorUsuario = (resumen) => {
  const grupos = [];
  const indice = new Map();

  (Array.isArray(resumen) ? resumen : []).forEach((row) => {
    const clave = String(row.usuario || "")
      .trim()
      .toLowerCase();
    if (!clave) return;
    let grupo = indice.get(clave);
    if (!grupo) {
      grupo = { usuario: row.usuario, filas: [] };
      indice.set(clave, grupo);
      grupos.push(grupo);
    }
    grupo.filas.push({
      accion: row.accion,
      cantidad: row.cantidad,
    });
  });

  return grupos;
};

export const filtrarDetalleUsuarioAccion = (registros, usuario, accion) => {
  const u = String(usuario || "")
    .trim()
    .toLowerCase();
  const a = String(accion || "")
    .trim()
    .toLowerCase();
  return filtrarUsuariosValidos(registros).filter(
    (row) =>
      String(row.usuario || "")
        .trim()
        .toLowerCase() === u &&
      String(row.accion || "")
        .trim()
        .toLowerCase() === a
  );
};

export const etiquetaPeriodo = (fechaDesde, fechaHasta) => {
  if (fechaDesde && fechaHasta && fechaDesde === fechaHasta) {
    return `día ${fechaDesde}`;
  }
  if (fechaDesde && fechaHasta) {
    return `${fechaDesde} → ${fechaHasta}`;
  }
  if (fechaDesde) return `desde ${fechaDesde}`;
  if (fechaHasta) return `hasta ${fechaHasta}`;
  return "sin filtro de fechas";
};
